export interface OrganizationContext {
  organizationId: number;
  organizationSlug: string;
  organizationName?: string;
}

const ORG_ID_KEY = 'activeOrganizationId';
const ORG_SLUG_KEY = 'activeOrganizationSlug';
const ORG_NAME_KEY = 'activeOrganizationName';

export const setOrganizationContext = (context: OrganizationContext) => {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.setItem(ORG_ID_KEY, String(context.organizationId));
  sessionStorage.setItem(ORG_SLUG_KEY, context.organizationSlug);
  if (context.organizationName) {
    sessionStorage.setItem(ORG_NAME_KEY, context.organizationName);
  } else {
    sessionStorage.removeItem(ORG_NAME_KEY);
  }
};

export const clearOrganizationContext = () => {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.removeItem(ORG_ID_KEY);
  sessionStorage.removeItem(ORG_SLUG_KEY);
  sessionStorage.removeItem(ORG_NAME_KEY);
};

export const getOrganizationContext = (): OrganizationContext | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const idValue = sessionStorage.getItem(ORG_ID_KEY);
  const slugValue = sessionStorage.getItem(ORG_SLUG_KEY);
  const nameValue = sessionStorage.getItem(ORG_NAME_KEY);

  if (!idValue || !slugValue) {
    return null;
  }

  const id = Number(idValue);
  if (!Number.isFinite(id) || id <= 0) {
    return null;
  }

  return {
    organizationId: id,
    organizationSlug: slugValue,
    organizationName: nameValue || undefined,
  };
};

export const getEffectiveOrganizationId = (): number | null => {
  return getOrganizationContext()?.organizationId ?? null;
};

export const getOrganizationHeaders = (): Record<string, string> => {
  const context = getOrganizationContext();
  if (!context) {
    return {};
  }

  return {
    'X-Organization-Id': String(context.organizationId),
  };
};

export const withOrganizationSlug = (path: string): string => {
  if (!path.startsWith('/')) {
    return path;
  }

  const context = getOrganizationContext();
  if (!context) {
    return path;
  }

  return `/${context.organizationSlug}${path}`;
};
